import React from 'react';
import { useEffect, useRef, useState } from 'react';
import ArrowLeft from '../../../../_styles/images/ArrowLeft.png';
import { Link } from 'react-router-dom';
import Van from '../../../../_styles/images/SUV.svg';
import { connect } from 'react-redux';
import * as actionTypes from '../../../../redux/actionTypes';
import SecondaryCardNoticePopup from './SecondaryCardNoticePopup';
import Loading from '../../../../shared/loading/Loading';
import analyticsService from "../../../../shared/analytics/analytics-service";


function UpgradeToDriver(props) {

  const navigationAlertNode = useRef(null);

  const [selectedDays, updateSelectedDays] = useState([]);
  const [showSCRUDPopup, updateShowSCRUDPopup] = useState(false);
  const [loading, updateLoading] = useState(false);
  const [isDriverPending, updateDriverPending] = useState(false);

  useEffect(() => {
    if (props.vanpoolInfo) {
      if (props.vanpoolInfo.commuteDays) {
        updateSelectedDays(props.vanpoolInfo.commuteDays);
      }
    }
  }, [props.vanpoolInfo])

  useEffect(() => {
    if(props.loaded){
      updateLoading(false);
      if(props.secondaryCardIsRequired){
        updateShowSCRUDPopup(true);
        analyticsService.analyticsProcessEvent({
          "event": "modal_view_generic",
          "context": {
              "event_action": "subscription cost exceeds benefit card maximum modal"
          }
      });
      }else{
        if(!props.secondaryCardCheckError){
          props.updateSecondaryCardLoading();
          props.history.push("/myprofile/change/plan/licenseNotification");
        }
      }
    }

  },[props.secondaryCardIsRequired, props.loaded])

  useEffect(() => {
    if (props.driverStatus && props.driverStatus.toLowerCase().includes('pending')) {
      updateDriverPending(true);
    }
  }, [props.driverStatus])

  function checkNextStep() {
    props.saveSelectedPlan({ ...props.selectedPlan, days: selectedDays })
    var paymentCards = props.payment.cards;
    const combinedPayments = [...(paymentCards || []), ...(props.paymentCards || [])];
    var isFed = combinedPayments.filter((card) => (card.isFederalBenefitCard || card.isCommuterBenefitCard) && card.isPrimary );
    if(isFed && isFed.length > 0){
      const payload = {
        packageName: props.selectedPlan.packageName,
        packageDiscountType: props.selectedPlan.role,
        employerId: props.employerId
      }
      updateLoading(true);
      props.checkIfSecondaryCardIsRequired(payload);
    }else{
      if(isDriverPending){
        props.getDocusignContract(true, props.vanpoolInfo.id, props.history, '/myprofile/change/plan/summary'); //check if need to go to driver summary or normal summary
      } else {
      props.history.push("/myprofile/change/plan/licenseNotification");
      }
    }
  }

  return (
    <div className="change-subscription-container">
      <div className="change-subscription-page upgrade-section">
      <Loading isLoading={loading} />
        <div className="header">
          <div className="backArrow">
            <Link className="overview-link" onClick={props.history.goBack} aria-label="Go back to previous page">
              <img alt="go back" src={ArrowLeft}></img>
            </Link>
          </div>
          <div className="heading">Change Subscription Plan</div>
        </div>
        <div className="container">
          <div className='upgrade-content'>
            <div className='left-section'>
              {props.selectedPlan && <h2 className='header-text small'>You’ve upgraded to a Driver Plan!</h2>}
              <div className='comment-text driver'>Your new subscription rate may take effect when your driver application is approved.</div>
              <div className='comment-text driver'>Prorated amounts owed for the upgraded plan for this month will be reflected in an upcoming invoice.</div>
              <div className='comment-text driver'>If needed, you can change your commute days later in your profile.</div>
              <div className='your-days-label'>Your commute days</div>
              <div className="oprational-days">
                {selectedDays.map(day => ({
                  day,
                })).map(({ day }) =>
                (
                  <button
                    day={day}
                    key={day}
                    type="button"
                    disabled={true}
                    aria-label='available'
                    className='day-btn not-active'
                  >
                    {day.substr(0, 3)}
                  </button>
                ))}
              </div>
            </div>
            <div className='right-section'>
              <img src={Van} alt='van image'></img>
            </div>
          </div>
          <div className="buttons">
            <button className='cancel-button' onClick={props.history.goBack}>cancel</button>
            <button className='continue-button' onClick={checkNextStep}>Continue</button>
          </div>
        </div>
      </div>
      {
            showSCRUDPopup && <SecondaryCardNoticePopup close={() => updateShowSCRUDPopup(false)}  history={props.history} updateSecondaryCardModal={() => props.updateSecondaryCardModal()} licenseNotification={true} />
      }
    </div>
  );
}

function mapStateToProps(state) {
  return {
    selectedPlan: state.profile.selectedPlan,
    vanpoolInfo: state.profile.vanpool,
    loaded: state.profile.isLoaded,
    paymentCards: state.profile.paymentCards,
    employerId: state.profile.employerId,
    secondaryCardIsRequired: state.profile.secondaryCardIsRequired,
    loaded: state.profile.secondaryCardCheckCompleted,
    secondaryCardCheckError: state.profile.secondaryCardCheckError,
    driverStatus: state.profile.driverUpdatedStatus,
    payment: state.payments
  }
}

function mapDispatchToProps(dispatch) {
  return {
    saveSelectedPlan(selectedPackage) {
      dispatch({ type: actionTypes.SET_SELECTED_PLAN, data: selectedPackage });
    },
    checkIfSecondaryCardIsRequired(payload) {
      dispatch({ type: actionTypes.CHECK_SECONDARY_CARD_REQUIRED, data: payload})
    },
    updateSecondaryCardLoading() {
      dispatch({ type: actionTypes.UPDATE_SECONDARY_CARD_LOADING})
    },
    updateSecondaryCardModal() {
      dispatch({ type: actionTypes.SECONDARY_CARD_IS_REQUIRED, data:  {isRequired: false, checkCompleted: false} })
    },
    getDocusignContract(isDriver, vanpoolId, history, navigateTo) {
      dispatch({ type: actionTypes.APPLY_TO_SIGN_CONTRACT, data: { isDriver: isDriver, vanpoolId: vanpoolId, history, navigateTo } })
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(UpgradeToDriver);